import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44984cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "message"
}
const _hoisted_2 = { class: "message__inner" }
const _hoisted_3 = { class: "df mt-15 search-wrapper" }
const _hoisted_4 = { class: "w-100" }
const _hoisted_5 = {
  key: 0,
  class: "icon icon-back"
}
const _hoisted_6 = { class: "img" }
const _hoisted_7 = {
  key: 1,
  class: "d-wrapper"
}
const _hoisted_8 = { class: "d-container" }
const _hoisted_9 = { class: "d-aside" }
const _hoisted_10 = { class: "d-aside__main-menu" }
const _hoisted_11 = { class: "d-aside__nav" }
const _hoisted_12 = { class: "d-chat" }
const _hoisted_13 = { class: "img" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_search = _resolveComponent("app-search")!
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_app_header = _resolveComponent("app-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_app_photo_view = _resolveComponent("app-photo-view")!
  const _component_app_file_view = _resolveComponent("app-file-view")!
  const _component_message_group_chat_info = _resolveComponent("message-group-chat-info")!
  const _component_app_media_view = _resolveComponent("app-media-view")!
  const _component_desktop_header = _resolveComponent("desktop-header")!
  const _component_drive_aside_main_menu = _resolveComponent("drive-aside-main-menu")!
  const _component_messages_conversations = _resolveComponent("messages-conversations")!
  const _component_drive_media_view = _resolveComponent("drive-media-view")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_app_header, null, _createSlots({
            "top-left": _withCtx(() => [
              (!_ctx.hideBack)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "javascript:void(0);",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backAction && _ctx.backAction(...args)), ["prevent"])),
                    class: "back-link"
                  }, [
                    (_ctx.backArrow)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_5))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            "top-middle": _withCtx(() => [
              (_ctx.messagesStore.currentConversation)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "contact-wrapper",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.conversationNameClicked && _ctx.conversationNameClicked(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_app_lazy_image, {
                        url: _ctx.photoUrl,
                        key: _ctx.photoUrl,
                        alt: "contact photo"
                      }, null, 8, ["url"])
                    ]),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.messagesStore.currentConversation.info.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, [
            (_ctx.showSearch)
              ? {
                  name: "bottom",
                  fn: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_app_search, {
                          modelValue: _ctx.spacesStore.search,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spacesStore.search) = $event)),
                          onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.spacesStore.search = '')),
                          placeholder: _ctx.$localize('messages.placeholder.search')
                        }, null, 8, ["modelValue", "placeholder"])
                      ])
                    ])
                  ])
                }
              : undefined
          ]), 1024),
          _createVNode(_component_router_view, { "loader-text": _ctx.loaderText }, null, 8, ["loader-text"]),
          (_ctx.driveStore.fullscreenPhoto)
            ? (_openBlock(), _createBlock(_component_app_photo_view, {
                key: 0,
                photo: _ctx.driveStore.fullscreenPhoto,
                onClose: _ctx.closeFullScreen,
                "disable-swipe": "",
                "view-only": ""
              }, null, 8, ["photo", "onClose"]))
            : _createCommentVNode("", true),
          (_ctx.driveStore.fullscreenFile)
            ? (_openBlock(), _createBlock(_component_app_file_view, {
                key: 1,
                onClose: _ctx.closeFullScreen
              }, null, 8, ["onClose"]))
            : _createCommentVNode("", true),
          (_ctx.isGroupInfo)
            ? (_openBlock(), _createBlock(_component_message_group_chat_info, {
                key: 2,
                onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isGroupInfo = false))
              }))
            : _createCommentVNode("", true),
          (_ctx.driveStore.appPhotoViewMedia)
            ? (_openBlock(), _createBlock(_component_app_media_view, {
                key: 3,
                onOnClose: _ctx.closeFullScreen
              }, null, 8, ["onOnClose"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_7, [
        _createVNode(_component_desktop_header),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_drive_aside_main_menu)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", null, [
                _createVNode(_component_messages_conversations, {
                  conversation: _ctx.messagesStore.conversations
                }, null, 8, ["conversation"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.currentPage !== _ctx.NAVIGATION_PAGES.MESSAGES_MY ? 'd-border' : '')
            }, [
              (_ctx.messagesStore.currentConversation)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "d-contact-wrapper",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.conversationNameClicked && _ctx.conversationNameClicked(...args)))
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_app_lazy_image, {
                        url: _ctx.photoUrl,
                        key: _ctx.photoUrl,
                        alt: "contact photo"
                      }, null, 8, ["url"])
                    ]),
                    _createElementVNode("h5", null, _toDisplayString(_ctx.messagesStore.currentConversation.info.name), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode(_component_router_view, { "loader-text": _ctx.loaderText }, null, 8, ["loader-text"]),
            (_ctx.driveStore.fullscreenPhoto)
              ? (_openBlock(), _createBlock(_component_app_photo_view, {
                  key: 0,
                  photo: _ctx.driveStore.fullscreenPhoto,
                  onClose: _ctx.closeFullScreen,
                  "disable-swipe": "",
                  "view-only": ""
                }, null, 8, ["photo", "onClose"]))
              : _createCommentVNode("", true),
            (_ctx.driveStore.fullscreenFile)
              ? (_openBlock(), _createBlock(_component_app_file_view, {
                  key: 1,
                  onClose: _ctx.closeFullScreen
                }, null, 8, ["onClose"]))
              : _createCommentVNode("", true),
            (_ctx.isGroupInfo)
              ? (_openBlock(), _createBlock(_component_message_group_chat_info, {
                  key: 2,
                  onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isGroupInfo = false))
                }))
              : _createCommentVNode("", true),
            (_ctx.driveStore.appPhotoViewMedia)
              ? (_openBlock(), _createBlock(_component_drive_media_view, {
                  key: 3,
                  onOnClose: _ctx.closeFullScreen
                }, null, 8, ["onOnClose"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}